$(document).ready(function () {
  console.log("Document is ready!");
  let variantIds = {};
  let variantPrice = {};
  let sellingPlan;

  function findFirstMatchId(searchTerm) {
    // Create a case-insensitive regular expression
    const regex = new RegExp(searchTerm, "i");
    console.log("variantIds", variantIds);

    // Iterate over the variantIds object
    for (const [key, value] of Object.entries(variantIds)) {
      if (regex.test(key)) {
        return value; // Return the ID of the first matching key
      }
    }

    return null; // Return null if no match is found
  }

  function getValueByKey(obj, key) {
    return obj[key];
  }

  function updateVariant(searchTerm, productId) {
    const MatchId = findFirstMatchId(searchTerm);
    const MatchPrice = getValueByKey(variantPrice, MatchId);
    console.log(MatchPrice);
    if (MatchId) {
      $(`#variant_id_${productId}`).val(MatchId);
    }
    if (MatchPrice) {
      let formattedPrice = Shopify.formatMoney(+MatchPrice, "${{amount}}");
      let discountPrice = Shopify.formatMoney(
        +MatchPrice * 0.75,
        "${{amount}}"
      );
      $(".span-price-nosubs" + productId).text(formattedPrice);

      $(".product-price.no-subscription." + productId).text(formattedPrice);

      $("span.span-price" + productId + " strike").text(formattedPrice);
      $("span.span-price" + productId + " strong").text(discountPrice);
    }
    const matchingElement = $(
      `.product-variants_${productId}[data-variant-id="${MatchId}"]`
    );
    sellingPlan = matchingElement.data("selling-allocation");
    if (sellingPlan) {
      $("#plan_" + productId).val(sellingPlan);
      $(".subs_" + productId).css("display", "block");
    } else {
      $("#plan_" + productId).val("");
      $(".subs_" + productId).css("display", "none");
    }
  }

  // Example: Handle subscription checkbox change
  $(".subscription_input").each(function () {
    $(this).on("change", function () {
      if ($(this).is(":checked")) {
        $(this)
          .closest(".product-card-subscribe")
          .find(".no-subscription")
          .removeClass("subscription-choice");
        $(this)
          .closest(".product-card-subscribe")
          .find(".with-subscription")
          .addClass("subscription-choice");
      } else {
        $(this)
          .closest(".product-card-subscribe")
          .find(".with-subscription")
          .removeClass("subscription-choice");
        $(this)
          .closest(".product-card-subscribe")
          .find(".no-subscription")
          .addClass("subscription-choice");
      }
    });
  });

  // Loop through each Add to Cart button and its corresponding flavor selector
  $(".btn-primary.AddToCart").each(function () {
    const btnAtc = $(this);
    const productId = btnAtc.attr("id").split("_")[1];
    const variantSelector = $(`#variant-selector_${productId}`);

    // Prevent form submission if no flavor is selected
    btnAtc.on("click", function (event) {
      if (variantSelector.length > 0 && !variantSelector.val()) {
        event.preventDefault(); // Prevent form submission

        // Remove any existing error message
        $(`#variant-selector_${productId}`)
          .closest(".flavor-wrapper")
          .siblings(".error-message")
          .remove();

        // Display a message if no flavor is selected
        const errorMessage = $(
          '<p class="error-message" style="text-align: center; color: red; font-size: 14px;">Please select a flavor before adding to cart.</p>'
        );
        $(`#variant-selector_${productId}`)
          .closest(".flavor-wrapper")
          .after(errorMessage);

        // Hide the message after 3 seconds
        setTimeout(function () {
          errorMessage.remove();
        }, 2000);
      }
    });

    // Update variant ID when a flavor is selected
    variantSelector.on("change", function () {
      variantIds = {};
      sellingPlan = "";
      $(`input.product-variants_${productId}`).map(function () {
        let title = $(this).data("variant-title");
        let id = $(this).data("variant-id");
        let price = $(this).data("variant-price");

        if (title && id) {
          variantIds[title] = id;
        }

        if (price && id) {
          variantPrice[id] = price;
        }
      });
      if (variantSelector.val()) {
        let searchVar = variantSelector.val();
        updateVariant(searchVar, productId);
      }
    });
  });
});
